const shoe_sizes = [];
for (let i = 7; i <= 13.5; i += 0.5) {
    let uk = i-1;
    shoe_sizes.push({
        name: `${i}C`,
        value: `${i}C`,
        uk_size: `${uk}C`,
    })
}

for (let i = 1; i <= 16; i += 0.5) {
    let uk = '';
    if( i>=3 ){
        uk = i-1;
    }
    shoe_sizes.push({
        name: `${i}`,
        value: `${i}`,
        uk_size: uk,
    })
}

export default shoe_sizes;
